import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { qualityScorecardsAccessControl } from '../access-control/qualityScorecardsAccess.configuration'

const QualityScorecardsAdminOverviewPage = lazy(
  () =>
    import(
      /* webpackChunkName: "QualityScorecardsAdminOverviewPage" */
      '../pages/admin-overview/QualityScorecardsAdminOverviewPage'
    )
)

// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const qualityScorecardsAdminRouter = (
  <DomainRoute route="quality-scorecards-admin-overview">
    <DashSwitch>
      <DomainRoute
        exact
        route="quality-scorecards-admin-overview"
        component={QualityScorecardsAdminOverviewPage}
        accessControl={qualityScorecardsAccessControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
